module.exports = __webpack_public_path__ + "static/media/infohub.3b14a467.png";